// This presentation variant belongs exclusively to the public recording account.
// It never changes a tenant's identity, permissions, or accounting data.
export const DEMO_TENANT_ID = 'cf4c7f2e-7835-4108-895e-4c55199e2f06';

export function isDemoAccount(userOrId) {
  return (typeof userOrId === 'string' ? userOrId : userOrId?.id) === DEMO_TENANT_ID;
}

export function readPresentationUser() {
  try { return JSON.parse(globalThis.localStorage?.getItem('invoice_user') || 'null'); }
  catch { return null; }
}

// A database DATE is a civil date, not a UTC instant. Do not convert it to local time.
export function formatColombianDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/.exec(String(value || ''));
  if (!match) return 'Sin fecha';
  const [, year, month, day] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month)
      || date.getUTCDate() !== Number(day)) return 'Sin fecha';
  return `${day}/${month}/${year}`;
}

export function parseColombianDate(value) {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(value || '').trim());
  if (!match) return '';
  const [, day, month, year] = match;
  const iso = `${year}-${month}-${day}`;
  return formatColombianDate(iso) === `${day}/${month}/${year}` ? iso : '';
}

const money = new Intl.NumberFormat('es-CO', {
  style: 'currency', currency: 'COP', minimumFractionDigits: 2, maximumFractionDigits: 2,
});
export function formatColombianCurrency(value) {
  const number = Number(value ?? 0);
  return Number.isFinite(number) ? money.format(number) : 'Sin importe';
}

export function explainDemoObservation(value) {
  const labels = {
    default_expense_fallback: 'cuenta de respaldo; requiere revisión',
    tenant_semantic_history: 'historial de esta empresa',
    supplier_semantic_history: 'historial del proveedor',
    supplier_history_semantic: 'historial del proveedor',
    supplier_history_frequent: 'cuenta habitual del proveedor',
    supplier_default_account: 'cuenta configurada para el proveedor',
    supplier_default_account_fallback: 'cuenta configurada para el proveedor principal',
    supplier_erp_history_unique: 'cuenta del historial del proveedor',
    global_history_semantic: 'ejemplos de esta empresa',
    main_supplier_history_frequent: 'cuenta habitual del proveedor principal',
    tenant: 'ejemplo contable de esta empresa',
    machine_learning: 'modelo entrenado con el historial de esta empresa',
    tenant_ml: 'modelo entrenado con el historial de esta empresa',
    ui_override: 'cuenta elegida en la configuración',
    chart_of_accounts: 'coincidencia con el plan de cuentas',
  };
  return String(value || '').replace(/\(([^)]+)\)/g, (original, key) => labels[key] ? `(${labels[key]})` : original);
}
